var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("В данном разделе Вы можете загрузить бухгалтерские документы по Вашим проектам")]),_c('br'),(_vm.documents.length === 0)?_c('no-data'):_vm._l((_vm.documents),function(item){return _c('c-document-item',{key:item.key,attrs:{"data":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }